// src/components/Hero.jsx
import React from 'react';
import { Link } from 'react-scroll';

const Hero = () => {
  return (
    <section id="hero" style={styles.section}>
      {/* Decorative blobs */}
      <div style={styles.blobTopRight} aria-hidden="true" />
      <div style={styles.blobBottomLeft} aria-hidden="true" />

      {/* Bootstrap container + row */}
      <div className="container" style={{ maxWidth: 1200, position: 'relative', zIndex: 1 }}>
        <div className="row align-items-center gy-5 py-5">

          {/* ── Left column: text ── */}
          <div
            className="col-12 col-lg-6 text-center text-lg-start"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <span className="section-badge" data-aos="fade-right" data-aos-delay="50">
              Your Personal Guide to Wellness
            </span>

            <h1 style={styles.heading}>
              Healing Minds,<br />
              <span style={styles.headingAccent}>Empowering Lives.</span>
            </h1>

            <p style={styles.subtext} data-aos="fade-right" data-aos-delay="200">
              Professional. Compassionate. Confidential. Mental health support for
              individuals, couples, families, and children in Navi Mumbai.
            </p>

            {/* CTA buttons */}
            <div
              className="d-flex flex-wrap justify-content-center justify-content-lg-start gap-3 mb-4"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <Link
                to="contact"
                smooth={true}
                duration={600}
                offset={-80}
                className="btn-viha-primary"
              >
                Book Consultation
              </Link>
              <Link
                to="services"
                smooth={true}
                duration={600}
                offset={-80}
                className="btn-viha-outline"
              >
                Explore Our Services
              </Link>
            </div>

            {/* Trust badges */}
            <div
              className="d-flex flex-wrap justify-content-center justify-content-lg-start gap-2"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              {['✅ 100% Confidential', '🏆 10+ Years Experience', '💬 500+ Happy Clients'].map((t) => (
                <span key={t} style={styles.trustBadge}>{t}</span>
              ))}
            </div>
          </div>

          {/* ── Right column: illustration ── */}
          <div
            className="col-12 col-lg-6 d-flex justify-content-center"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            {/*
              To use a real image, replace the div below with:
              <img
                src="/assets/hero-image.svg"
                alt="Mental wellness illustration"
                className="img-fluid"
                style={{ maxWidth: 480 }}
              />
            */}
            <div style={styles.heroImagePlaceholder}>
              <div style={styles.heroIllustration}>
                <div style={styles.bigEmoji}>
                  <img src="Psychologist.png" alt="Brain Icon" style={{ width: '120%', height: '120%' }} />
                </div>
                <div style={styles.floatingCard1}><span>😌</span> Feeling Better</div>
                <div style={styles.floatingCard2}><span>💚</span> Safe Space</div>
                <div style={styles.floatingCard3}><span>⭐</span> 5-Star Care</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Wave bottom divider */}
      {/* <div className="wave-divider">
        <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#ffffff" />
        </svg>
      </div> */}
    </section>
  );
};

const styles = {
  section: {
    position: 'relative',
    paddingTop: 72,          /* matches navbar height */
    paddingBottom: 0,
    // background: 'linear-gradient(135deg, #D6E8F7 0%, #EBF4FF 40%, #ffffff 100%)',
    background: '#D9EAF8',
    overflow: 'hidden',
    minHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  blobTopRight: {
    position: 'absolute',
    top: -80,
    right: -80,
    width: 400,
    height: 400,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(90,158,75,0.12) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  blobBottomLeft: {
    position: 'absolute',
    bottom: 80,
    left: -120,
    width: 500,
    height: 500,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(27,63,110,0.08) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  heading: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(34px, 5vw, 54px)',
    fontWeight: 700,
    color: '#1B3F6E',
    lineHeight: 1.18,
    marginBottom: 20,
    marginTop: 8,
  },
  headingAccent: {
    color: '#5A9E4B',
    fontStyle: 'italic',
  },
  subtext: {
    fontSize: 17,
    color: '#4a5568',
    lineHeight: 1.8,
    marginBottom: 32,
    maxWidth: 480,
    margin: '0 auto 32px',  /* centers on mobile; overridden by text-lg-start parent */
  },
  trustBadge: {
    background: 'rgba(255,255,255,0.85)',
    border: '1px solid rgba(27,63,110,0.12)',
    borderRadius: 50,
    padding: '6px 16px',
    fontSize: 13,
    fontWeight: 600,
    color: '#1B3F6E',
    backdropFilter: 'blur(6px)',
    whiteSpace: 'nowrap',
  },
  heroImagePlaceholder: {
    width: 'min(380px, 90vw)',
    height: 'min(380px, 90vw)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: '0 20px 60px rgba(27,63,110,0.15)',
  },
  heroIllustration: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  bigEmoji: {
    fontSize: 'clamp(64px, 18vw, 100px)',
    filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.1))',
  },
  floatingCard1: {
    position: 'absolute',
    top: 40,
    right: 10,
    background: '#fff',
    borderRadius: 50,
    padding: '8px 18px',
    fontSize: 13,
    fontWeight: 700,
    color: '#1B3F6E',
    boxShadow: '0 4px 16px rgba(27,63,110,0.15)',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    animation: 'floatY 3s ease-in-out infinite',
    whiteSpace: 'nowrap',
  },
  floatingCard2: {
    position: 'absolute',
    bottom: 60,
    right: 0,
    background: '#fff',
    borderRadius: 50,
    padding: '8px 18px',
    fontSize: 13,
    fontWeight: 700,
    color: '#5A9E4B',
    boxShadow: '0 4px 16px rgba(90,158,75,0.15)',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    animation: 'floatY 3.5s ease-in-out infinite 0.5s',
    whiteSpace: 'nowrap',
  },
  floatingCard3: {
    position: 'absolute',
    bottom: 50,
    left: 10,
    background: '#fff',
    borderRadius: 50,
    padding: '8px 18px',
    fontSize: 13,
    fontWeight: 700,
    color: '#F5A623',
    boxShadow: '0 4px 16px rgba(245,166,35,0.15)',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    animation: 'floatY 4s ease-in-out infinite 1s',
    whiteSpace: 'nowrap',
  },
};

export default Hero;